export default {
  groupName: 'adpi-category-tech',
  appName: 'Tech Category',
  baseRoute: '/dashboard/adpi-category-tech',
  label: 'AdPi Quickview Tech Devices Dashboard',
  home: '/slicer',
  image: 'marketcast.png',
  description: 'AdPi Quickview Tech Devices Dashboard'
}
